import { Tooltip, RadioGroup, Radio } from '@blueprintjs/core';
import { applicationModeOptions } from '../applicationModeOptions';
import styles from './Lender.module.css';
import { Controller } from 'react-hook-form';
import { useLoanApplication } from '@axo/shared/data-access/hooks';

export function SelectApplicantMode({
  applicationID,
}: {
  applicationID: string;
}) {
  const { data: applicationData } = useLoanApplication(applicationID);
  const hasCoApplicant = Boolean(applicationData?.CoApplicantCustomerID);

  return (
    <Controller
      name="ApplicantMode"
      render={({ field }) => (
        <Tooltip
          disabled={hasCoApplicant}
          content={'This application does not have a co-applicant'}
        >
          <div>
            <RadioGroup
              disabled={!hasCoApplicant}
              className={styles.radio}
              onChange={field.onChange}
              onBlur={field.onBlur}
              selectedValue={field.value}
            >
              {applicationModeOptions.map((applicantMode) => (
                <Radio
                  label={applicantMode.label}
                  value={applicantMode.value}
                  key={applicantMode.value}
                />
              ))}
            </RadioGroup>
          </div>
        </Tooltip>
      )}
    />
  );
}
